/** F-186: other parts of the app (the avatar panel) open the push prompt dialog on a step. */
export type PushDialogStep = 'install' | 'openInstalled' | 'enable' | 'blocked'

export const OPEN_PUSH_PROMPT_EVENT = 'memberfy:push-prompt'

export const openPushPrompt = (step: PushDialogStep) => {
  window.dispatchEvent(new CustomEvent(OPEN_PUSH_PROMPT_EVENT, { detail: { step } }))
}
